import { type KeyboardEvent, useCallback } from 'react';

import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import { type StyleProp } from '@adsk/alloy-react-theme';

const useOpenableTag = ({
  isOpen,
  disabled,
  onIsOpenChange,
  style,
}: {
  isOpen: boolean | undefined;
  disabled: boolean | undefined;
  onIsOpenChange: (() => void) | undefined;
  style: StyleProp | undefined;
}) => {
  const openable = isOpen !== undefined;

  const onKeyDown = useCallback(
    (e: KeyboardEvent<HTMLElement>) => {
      if (!openable || disabled) {
        return;
      }

      if (e.key === 'ArrowDown' && !isOpen) {
        e.preventDefault();
        onIsOpenChange?.();
      } else if (e.key === 'ArrowUp' && isOpen) {
        e.preventDefault();
        onIsOpenChange?.();
      }
    },
    [openable, disabled, isOpen, onIsOpenChange],
  );

  const getOpenButtonProps = useCallback(() => {
    return {
      disabled,
      tabIndex: -1,
      size: 16,
      onClick: onIsOpenChange,
      renderIcon: ChevronDownIcon.renderIcon,
      style: [
        style,
        isOpen && {
          transform: 'rotate(180deg)',
        },
      ],
    };
  }, [disabled, isOpen, onIsOpenChange, style]);

  return { openable, onKeyDown, getOpenButtonProps };
};

export default useOpenableTag;
